<!--

  TODO: implement story #2617689

  https://dev.azure.com/tr-tax/TaxProf/_workitems/edit/2617689

  Header

-->
<div>
	<form bfmForm  [formGroup]="activityForm">
		<div class="row">
			<div id="form-group-code" class="col-md-4 col-sm-4 col-xs-12 form-group ng-bento">
				<label class="control-label inline" for="id-input"> {{ 'Core.Captions.Activity.Code' | translate }} * </label>
				<input
					bfmField
					[bfmLabel]="'Core.Captions.Activity.Code' | translate"
					autocomplete="bmOff"
					type="text"
					id="id-input"
					name="id-input"
					[attr.maxLength]="20"
					class="bento-input form-control"
					formControlName="ID"
					data-qe-id="activity-detail-id-input"
				/>
			</div>
		</div>
		<div class="row">
			<div id="form-group-name" class="col-md-4 col-sm-4 col-xs-12 form-group ng-bento">
				<label class="control-label inline" for="name-input"> {{ 'Core.Captions.Activity.Name' | translate }} * </label>
				<input
					bfmField
					[bfmLabel]="'Core.Captions.Activity.Name' | translate"
					autocomplete="bmOff"
					type="text"
					id="name-input"
					name="name-input"
					[attr.maxLength]="250"
					class="bento-input form-control"
					formControlName="name"
					data-qe-id="activity-detail-name-input"
				/>
			</div>
		</div>

		<div class="row">
			<div class="col-md-8 col-xs-12">
				<div class="form-group">
					<label for="form-invoice-description">{{ 'Core.Captions.Activity.InvoiceDescription' | translate }}</label>
					<textarea
						id="form-invoice-description"
						class="form-control"
						data-qe-id="activity-detail-invoice-description-textarea"
						rows="3"
					>
					</textarea>
				</div>
			</div>
		</div>
		<div class="row">
			<fieldset class="col-md-6 col-sm-8 col-xs-12 form-group">
				<legend>{{ 'Core.Captions.Activity.ActivityType' | translate }}</legend>
				<div ngbRadioGroup formControlName="typeOption">
					<label for="activity-type-time" class="radio-btn" ngbButtonLabel>
						<input ngbButton
							id="activity-type-time"
							type="radio"
							name="type-time"
							data-qe-id="activity-detail-type-time-radio-btn"
							[value]="TypeOptions.TIME"
						/>
						{{ 'Core.Enums.ActivityType.TIME' | translate }} </label
					><br />
					<label for="activity-type-expense" class="radio-btn" ngbButtonLabel>
						<input ngbButton
							id="activity-type-expense"
							type="radio"
							name="type-expense"
							data-qe-id="activity-detail-type-expense-radio-btn"
							[value]="TypeOptions.EXPENSE"
						/>
						{{ 'Core.Enums.ActivityType.EXPENSE' | translate }}
					</label>
				</div>
			</fieldset>
		</div>
		<div class="row">
			<fieldset class="col-md-4 col-sm-4 col-xs-6 form-group">
				<legend>{{ 'Core.Captions.Activity.Class' | translate }}</legend>
				<div ngbRadioGroup formControlName="classOption">
					<div *ngFor="let classOption of classOptionsMock">
						<label ngbButtonLabel for="class-radio-{{ classOption.id }}" class="radio-btn">
							<input ngbButton
								id="class-radio-{{ classOption.id }}"
								name="classOption-{{ classOption.id }}"
								type="radio"
								[value]="classOption.id"
								[attr.data-qe-id]="'activity-detail-class-radio-' + classOption.id"

							/>
							{{ classOption.name }}
						</label>
					</div>
				</div>
			</fieldset>

			<ng-container *ngIf="optionForClass === ClassOptions.administrative">
					<fieldset class="col-md-4 col-sm-4 col-xs-6 form-group">
						<legend>{{ 'Core.Captions.Activity.AdminType' | translate }}</legend>
						<div ngbRadioGroup>
							<label ngbButtonLabel for="form-admin-type-general" class="radio-btn">
								<input ngbButton
									id="form-admin-type-general"
									type="radio"
									name="admin-type-general"
									value="general"
									data-qe-id="activity-admin-type-general-radio">
								{{ 'Core.Enums.ActivityAdministrativeType.GENERAL' | translate }}
							</label><br>
							<ng-container *ngIf="optionForType === TypeOptions.TIME">
								<label ngbButtonLabel for="form-admin-type-accruable-benefit" class="radio-btn">
									<input ngbButton
										id="form-admin-type-accruable-benefit"
										type="radio"
										name="admin-type-accruable-benefit"
										value="accruable-benefit"
										data-qe-id="activity-admin-type-accruable-benefit-radio">
									{{ 'Core.Enums.ActivityAdministrativeType.ACCRUABLEBENEFIT' | translate }}
								</label><br>
							</ng-container>
							<label ngbButtonLabel for="form-admin-type-cpe" class="radio-btn">
								<input ngbButton
									id="form-admin-type-cpe"
									type="radio"
									name="admin-type-cpe"
									value="cpe"
									data-qe-id="activity-admin-type-cpe-radio">
								{{ 'Core.Enums.ActivityAdministrativeType.CPE' | translate }}
							</label><br>
						</div>
					</fieldset>
			</ng-container>
		</div>

		<!--

		TODO: implement story #2619608

		https://dev.azure.com/tr-tax/TaxProf/_workitems/edit/2619608

		-->
		<div class="row">
			<fieldset class="col-md-4 col-sm-4 col-xs-12 form-group">
				<legend>{{'Core.Captions.Activity.Status' | translate}}</legend>
				<div ngbRadioGroup formControlName="activityStatus"
						ngDefaultControl
						class="btn-group status-radio-btn-group"
						name="activityDetailsStatus">
				<label ngbButtonLabel
							for="activity-details-status-active"
							[ngClass]="{'status-radio-btn-active': selectedActivityStatus === 'active'}">
				<input ngbButton
								id="activity-details-status-active"
								type="radio"
								value="active"
								data-qe-id="activity-details-status-active-radio-btn" />
				{{'Core.Enums.ActivityStatus.ACTIVE' | translate}}
				</label>
				<label ngbButtonLabel
							for="activity-details-status-inactive"
							[ngClass]="{'status-radio-btn-active': selectedActivityStatus === 'inactive'}">
				<input ngbButton
								id="activity-details-status-inactive"
								type="radio"
								value="inactive"
								data-qe-id="activity-details-status-inactive-radio-btn" />
				{{'Core.Enums.ActivityStatus.INACTIVE' | translate}}
				</label>
			</div>
			</fieldset>
		</div>

		<!--

		TODO: implement story #2619863

		https://dev.azure.com/tr-tax/TaxProf/_workitems/edit/2619863

		-->
		<div class="row">
			<div class="col-md-4 col-sm-4 col-xs-12 form-group">
				<label for="gl-account">{{'Core.Captions.Activity.GeneralLedgerAccount' | translate }}</label>
				<input id="gl-account"
						class="form-control"
						type="text"
						maxlength="60"
						data-qe-id="activity-detail-gl-account-input"
					/>
			</div>
		</div>

		<div class="ng-bento col-md-4 col-sm-4 col-xs-12 pl-0">
			<h3>{{'Onvio.Setup.Activities.ActivityDetail.GroupingsSectionHeader' | translate }}</h3>
			<bento-combobox
				class="activity-category-combobox"
				[inputLabelText]="'Core.Captions.Activity.ActivityCategory' | translate"
				[itemsObservable]="activityCategoryDataStream"
				[options]="activityCategoryComboboxOptions"
				data-qe-id="activity-category-combobox">
			</bento-combobox>
		</div>

		<div class="row">
			<h3 class="col-md-6">{{'Onvio.Setup.Activities.ActivityDetail.RatesSectionHeader' | translate}}</h3>
		</div>
		<ng-container *ngIf="optionForType === TypeOptions.TIME">
			<div class="row">
				<fieldset class="col-md-4 col-sm-4 col-xs-6 form-group">
					<legend>{{ 'Core.Captions.Activity.RateType' | translate }}</legend>
					<div ngbRadioGroup formControlName="rateOption">
						<label ngbButtonLabel for="form-rate-type-noRate" class="radio-btn">
							<input ngbButton
								id="form-rate-type-noRate"
								type="radio"
								name="rate-type-noRate"
								[value]="RateOptions.NORATE"
								data-qe-id="activity-rate-type-noRate-radio"
							>
							{{ 'Core.Enums.RateType.NORATE' | translate }}
						</label><br>
						<label ngbButtonLabel for="form-rate-type-staff" class="radio-btn">
							<input ngbButton
								id="form-rate-type-staff"
								type="radio"
								name="rate-type-staff"
								[value]="RateOptions.STAFF"
								data-qe-id="activity-rate-type-staff-radio"
							>
							{{ 'Core.Enums.RateType.EMPLOYEERATE' | translate }}
						</label><br>
						<label ngbButtonLabel for="form-rate-type-fixed" class="radio-btn">
							<input ngbButton
								id="form-rate-type-fixed"
								type="radio"
								name="rate-type-fixed"
								[value]="RateOptions.FIXED"
								data-qe-id="activity-rate-type-fixed-radio"
							>
							{{ 'Core.Enums.RateType.FIXEDRATE' | translate }}
						</label><br>
					</div>
				</fieldset>

				<ng-container *ngIf="optionForRate === RateOptions.STAFF">
					<!--
						TODO: implement story #2634924
						https://dev.azure.com/tr-tax/TaxProf/_workitems/edit/2634924 (Anton Mikhalchenko)
					-->
				</ng-container>

				<ng-container *ngIf="optionForRate === RateOptions.FIXED">
					<!--
						TODO: implement story #2634953
						https://dev.azure.com/tr-tax/TaxProf/_workitems/edit/2634953 (Dmytro Iatsenko)
					-->
					<div class="col-md-4 col-sm-4 col-xs-6">
						<label class="control-label" for="unitPrice">
							{{ 'Core.Captions.ClientEngagement.FixedRate' | translate }}
							<!-- ngIf: bmpControlGroupLabelTooltip -->
						</label>
						<input
							autocomplete="bmOff"
							type="text" id="unitPrice"
							class="form-control"
							formControlName="fixedRate"
							data-qe-id="unitPrice-label"
							appCurrency>
					</div>
				</ng-container>
			</div>
		</ng-container>
		<ng-container *ngIf="optionForType === TypeOptions.EXPENSE">
			<div class="row">
				<div class="col-md-4 col-sm-4 col-xs-6 form-group">
					<label class="control-label" for="form-unitPrice">
						{{ 'Core.Captions.Activity.UnitPrice' | translate }}
					</label>
					<input
						autocomplete="bmOff"
						type="text" id="form-unitPrice"
						class="form-control"
						formControlName="unitPrice"
						data-qe-id="activity-detail-unitPrice-label"
						appCurrency
						currencyFormat="1.4-4">
				</div>
				<div class="col-md-4 col-sm-4 col-xs-6 form-group">
					<label class="control-label" for="form-unitCost">
						{{ 'Core.Captions.Activity.UnitCost' | translate }}
					</label>
					<input
						autocomplete="bmOff"
						type="text" id="form-unitCost"
						class="form-control"
						formControlName="unitCost"
						data-qe-id="activity-detail-unitCost-label"
						appCurrency
						currencyFormat="1.4-4">
				</div>
			</div>
		</ng-container>

		<div class="row">
			<div class="col-md-6 col-sm-8 col-xs-12 form-group calculation-types">
				<input type="checkbox"
					name="roundExtension"
					id="roundExtension"
					data-qe-id="activity-admin-type-round-extention-checkbox">
				<label for="roundExtension"> {{ 'Core.Captions.Activity.RoundExtension' | translate }} </label>
			</div>
		</div>
		<ng-container *ngIf="optionForClass === ClassOptions.billable">
			<div class="row">
				<div class="col-md-4 col-sm-4 col-xs-6 form-group ng-bento">
					<label for="form-surcharge-method">{{'Core.Captions.Activity.SurchargeMethod' | translate}}</label>

					<div id="form-group-surcharge">
						<bento-combobox [attr.aria-label]="'Core.Captions.Activity.SurchargeMethod' | translate"
							formControlName="surchargeMethod"
							[itemsObservable]="surchargeOptions"
							[options]="comboboxOptions"
							[rowTemplate]="surchargeDateTemplate"
							data-qe-id="activity-detail-surcharge-combobox"
							id="form-surcharge-method">
						</bento-combobox>
						<ng-template #surchargeDateTemplate let-$data="data" let-$options="options">
							<div class="surcharge-combo-label">
								<label>{{$data.row.name}}</label>
							</div>
						</ng-template>
					</div>
				</div>
			</div>
		</ng-container>
		<ng-container *ngIf="optionForClass === ClassOptions.billable">
			<div class="row">
				<h3 class="col-md-6">{{'Onvio.Setup.Activities.ActivityDetail.TaxCalculationsSectionHeader' | translate}}</h3>
			</div>
			<div class="row">
				<div class="col-md-6 col-sm-8 col-xs-12 form-group calculation-types">
					<input id="form-charge-vat"
						type="checkbox"
						name="charge-vat"
						data-qe-id="activity-detail-charge-tax-checkbox">
					<label for="form-charge-vat"> {{ 'Core.Captions.Activity.ChargeSalesTax' | translate}} </label>
				</div>
			</div>
		</ng-container>
	</form>
</div>
